<template>
  <div :class="classObj" class="app-wrapper">
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <sidebar class="sidebar-container" :menu="menu" />
    <!-- <newSidebar v-for="(item, index) in menu" :key="index" :colorIndex="index" :menu="item"></newSidebar> -->
    <div class="main-container">
      <navbar ref="refNavBar" />
      <AppMain :closeit="closeit" />
    </div>
  </div>
</template>

<script>
import { SideBarMenu } from "./components/Sidebar/models/SideBarMenu";
import { SideBarMenuItem } from "./components/Sidebar/models/SideBarMenuItem";

import MenuUtils from "./components/Sidebar/models/MenuUtils";
import newSidebar from "./components/Sidebar/SideBarMenu";
import { Navbar, Sidebar, AppMain } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import CFScriptHelper from "@/common/js/CFScriptHelper";
import ChatSignalrService from "@/services/admin/ChatSignalrService";
import UserNotificationHelper from "./UserNotificationHelper";
export default {
  name: "Layout",
  components: {
    Navbar,
    Sidebar,
    newSidebar,
    AppMain,
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },

    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  created() {
    this.menu = MenuUtils.getMenu.items;
    // console.log("created");
    // if (
    //   this.$router.app._router.history.current.path == "/helpCenter/workBook"
    // ) {
    //   this.menu = [
    //     new SideBarMenuItem("接口管理", "Pages.Api", "pingzheng02", "api", [
    //       new SideBarMenuItem(
    //         "接口检测",
    //         "Pages.ApiCheck",
    //         "shengcheng",
    //         "/api/apiCheck"
    //       ),
    //     ]),
    //   ];
    // } else {
    //   this.menu = MenuUtils.getMenu.items;
    // }
    //this.registerToEvents();
  },
  mounted() {
    // if (this.application.features['SignalR']||true) {
    CFScriptHelper.initSignalR(() => {
      ChatSignalrService.init();
    });
    // console.log("mounted");
  },
  methods: {
    closeit() {
      this.$refs.refNavBar.closeit();

      // console.log("closeit");
    },
    registerToEvents() {
      cf.event.on("profilePictureChanged", async () => {
        await this.getProfilePicture();
      });

      cf.event.on("app.chat.unreadMessageCountChanged", (messageCount) => {
        this.unreadChatMessageCount = messageCount;
      });

      cf.event.on("app.chat.connected", () => {
        this.chatConnected = true;
      });

      cf.event.on("cf.notifications.received", async (userNotification) => {
        UserNotificationHelper.show(userNotification);
        await this.loadNotifications();
      });

      cf.event.on("app.notifications.refresh", async () => {
        await this.loadNotifications();
      });

      cf.event.on("app.notifications.read", (userNotificationId) => {
        for (let i = 0; i < this.notifications.length; i++) {
          if (this.notifications[i].userNotificationId === userNotificationId) {
            this.notifications[i].state = "READ";
          }
        }

        this.unreadNotificationCount -= 1;
      });
    },
    handleClickOutside() {
      this.$store.dispatch("CloseSideBar", { withoutAnimation: false });
    },
    async loadNotifications() {
      // this.fetchMessage.MaxResultCount = 3;
      // var result = await NotificationService.getUserNotifications(
      //   this.fetchMessage
      // );
      // this.unreadNotificationCount = result.unreadCount;
      // this.notifications = [];
      // $.each(result.items, (index, item) => {
      //   this.notifications.push(UserNotificationHelper.format(item));
      // });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
</style>
